export const getNumberPositivityStatus = (value: number): 'positive' | 'negative' | 'zero' => {
  if (value > 0) {
    return 'positive';
  }

  if (value < 0) {
    return 'negative';
  }

  return 'zero';
};
